import type { JunipProduct } from 'types/reviews';
import type { JunipProductWithReviews } from 'types/reviews/JunipProduct';

import { MIN_NUM_OF_REVIEWS } from '../constants';

export function hasReviews(
  product: JunipProduct,
): product is JunipProductWithReviews {
  return (
    product?.ratingAverage !== null &&
    product?.ratingAverage !== undefined &&
    product?.ratingCount !== null &&
    product?.ratingCount !== undefined
  );
}

export function hasEnoughReviews(
  product: JunipProduct,
): product is JunipProductWithReviews {
  return hasReviews(product) && product.ratingCount >= MIN_NUM_OF_REVIEWS;
}
